export default {
  settingsSideBar: {
    help: "Help",
    group: "Group",
  },
}
